module.exports = __webpack_public_path__ + "img/banner_title.1e155d74.png";